export default "/_next/static/images/4e3cbdee2b2ead373e425b6e4485cc51.png";